module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XeJK5y/tc-custom/9781620100431.jpg?1728155712582",
      "alt": "This image is the cover for the book Scott Pilgrim Vol. 1: Precious Little Life, Scott Pilgrim"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scott Pilgrim Vol. 1: Precious Little Life, Scott Pilgrim\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Just when you thought you knew all there was to know about SCOTT PILGRIM comes SCOTT PILGRIM COLOR Hardcover VOLUME 1: PRECIOUS LITTLE LIFE! The first in a series of brand-new Hardcover editions, this remastered, 6”x9” Hardcover presents Scott’s first “evil ex” battle as you’ve never seen it before—in full-color! Plus, previously unpublished extras and bonus materials make this mighty tome one that’s required reading for Scottaholics everywhere!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bryan Lee O'Malley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bryan Lee O'Malley is a Canadian cartoonist. His award-winning Scott Pilgrim series (2004-2010) was a New York Times best seller and the basis for the 2010 Universal film Scott Pilgrim Vs the World. In 2023, he co-wrote and co-produced the Netflix animated series Scott Pilgrim Takes Off. His books, including Lost at Sea, Seconds, and Snotgirl, have been translated into over twenty languages. He lives in Los Angeles.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0